import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-020223d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news-detail-page light" }

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import NewsDetail from './components/NewsDetail.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsDetailPage',
  setup(__props) {

const route = useRoute()

const newsId = computed<string | null>(() => {
  const id = route.query.selectedId
  if (id === undefined || id === null || id === '') return null
  return String(id)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NewsDetail, {
      "is-dark": false,
      "news-id": _unref(newsId),
      "hide-recommend": ""
    }, null, 8, ["news-id"])
  ]))
}
}

})